import { render, staticRenderFns } from "./DimensionSelectAccordian.vue?vue&type=template&id=20eb04c0&scoped=true"
import script from "./DimensionSelectAccordian.vue?vue&type=script&lang=js"
export * from "./DimensionSelectAccordian.vue?vue&type=script&lang=js"
import style0 from "./DimensionSelectAccordian.vue?vue&type=style&index=0&id=20eb04c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb04c0",
  null
  
)

export default component.exports